import {
  CompetencesType,
  ParceCompetencesType,
  MapedCompetencesType,
  Competences,
} from './types';

const parse = (data: Competences): Readonly<ParceCompetencesType> =>
  Object.freeze({
    id: data!.id || '',
    name: data!.name || '',
    image: data!.image || {},
    eventsCount: data!.events_count || 0,
    professionsCount: data!.professions_count || 0,
  });

const parseCompetences = (data: CompetencesType): MapedCompetencesType =>
  data.map((item) => parse(item));

export default parseCompetences;



// WEBPACK FOOTER //
// ./src/services/api/competences/utils/parseCompetences.ts